import { useEffect, useMemo, useState } from 'react';
import { X_HEADER_ID_NAME } from '@utils/constants';
import {
  CURRENT_TAB_ID,
  decrypt,
  sessionSetter,
  updateXHeaderId,
} from '@utils/storage';

export const useSessionHeaderSync = () => {
  const initial = useMemo(
    () => sessionSetter.getItem<Record<string, any>>(X_HEADER_ID_NAME) || {},
    []
  );
  const [xHeaderId, setXHeaderIdState] = useState(initial);

  useEffect(() => {
    const targetOrigin = window.location.origin;
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== targetOrigin) return;

      if (event.data.type === 'SECURE_DATA_RESPONSE') {
        const decrypted = decrypt(event.data.payload);

        if (decrypted) {
          const current =
            sessionSetter.getItem<Record<string, any>>(X_HEADER_ID_NAME) || {};
          const merged = { ...current, ...decrypted };
          sessionSetter.setItem(X_HEADER_ID_NAME, merged);
          setXHeaderIdState(merged);
        }
      }
    };

    window.addEventListener('message', handleMessage);

    if (window.opener) {
      window.opener.postMessage({ type: 'REQUEST_SECURE_DATA' }, targetOrigin);
    }

    return () => window.removeEventListener('message', handleMessage);
  }, []);

  return {
    tabId: CURRENT_TAB_ID,
    xHeaderId,
    setXHeaderId: (k: string, v: any) => {
      updateXHeaderId(k, v);
      setXHeaderIdState(sessionSetter.getItem(X_HEADER_ID_NAME) || {});
    },
  };
};
